import angular from 'angular';
import { BaseUiConfig } from './BaseUIConfig';
import { SearchServiceProvider } from '../Core';
import { ValueFilter } from "../Core";
import { QueryController } from "./Controllers/QueryController";
import { ResultsController } from "./Controllers/ResultsController";
import { FacetsController } from "./Controllers/FacetsController";
import { MetaController } from "./Controllers/MetaController";
import { PaginationController } from "./Controllers/PaginationController";
import { SortController } from "./Controllers/SortController";
import { SearchBootstrapper } from "./SearchBootstrapper";

// Set up the default filters
let defaultFilters = [
	new ValueFilter({ id: 'q' }),
	new ValueFilter({ id: 'page' })
];

// Register an angular module
let SearchModule = angular.module('velir.search', []);

// Register UI configuration as constant
SearchModule.value('uiConfig', BaseUiConfig);

// Register the search service provider
SearchModule.provider('searchService', SearchServiceProvider);

// Register the search bootstrapper
SearchModule.service('searchBootstrapper', SearchBootstrapper);

// Register controllers
SearchModule.controller('searchQueryController',  QueryController);
SearchModule.controller('searchResultsController',  ResultsController);
SearchModule.controller('searchFacetsController',  FacetsController);
SearchModule.controller('searchMetaController',  MetaController);
SearchModule.controller('searchPaginationController',  PaginationController);
SearchModule.controller('searchSortController', SortController);

// Configure the search service
SearchModule.config(function(searchServiceProvider) {
	searchServiceProvider
		.setFilters(defaultFilters);
});

SearchModule.run(function(searchBootstrapper) {
	searchBootstrapper.bootstrap();
});

export { SearchModule }
